/**
 * API path'lar — barcha service'lar shu yerdan import qiladi.
 * Javob format: { data, meta? }. Auth: Bearer token.
 * Javob formati: { data, meta? }
 */

export const endpoints = {
  // Auth
  auth: {
    sendSms: '/api/auth/send-sms',
    verifySms: '/api/auth/verify-sms',
    verifyLogin: '/api/auth/verify-login',
    /** Telefon + parol (SMS o‘rniga) — backend implementatsiyasi */
    loginPassword: '/api/auth/login-password',
    sendLoginOtp: '/api/auth/send-login-otp',
    resetPassword: '/api/auth/reset-password',
    refresh: '/api/auth/refresh',
    logout: '/api/auth/logout',
    validateRoleSwitchPin: '/api/auth/validate-role-switch-pin',
    impersonateCashier: '/api/auth/impersonate-cashier',
    /** Kassir → Mijoz (tenant egasi): PIN tekshirib token almashtiradi */
    switchToOwner: '/api/auth/switch-to-owner',
    /** Kassir → boshqa Kassir: PIN tekshirib token almashtiradi */
    switchToCashier: '/api/auth/switch-to-cashier',
    impersonationTargets: '/api/auth/impersonation-targets',
    adminImpersonate: '/api/auth/admin-impersonate',
  },
  user: '/api/user',
  userUpdatePhone: '/api/user/phone',
  userRoleSwitchPin: '/api/user/role-switch-pin',
  userChangePassword: '/api/user/password',
  sessions: '/api/sessions',
  sessionsRevoke: '/api/sessions/revoke',
  sessionsRevokeOthers: '/api/sessions/others',

  // Rollar va sidebar
  roles: '/api/roles',
  sidebar: '/api/sidebar',

  // Reference (public)
  regions: '/api/regions',
  districts: '/api/districts',
  districtsByRegion: (regionId) => `/api/regions/${regionId}/districts`,
  businessTypes: '/api/business-types',
  tariffs: '/api/tariffs',
  integrations: '/api/integrations',
  landingTeam: '/api/landing-team',
  tariffById: (id) => `/api/tariffs/${id}`,
  integrationById: (id) => `/api/integrations/${id}`,
  landingTeamById: (id) => `/api/landing-team/${id}`,

  // Mijozlar (tenants)
  tenants: '/api/tenants',
  tenantById: (id) => `/api/tenants/${id}`,
  tenantProducts: (id) => `/api/tenants/${id}/products`,
  tenantReceiptLayout: (id) => `/api/tenants/${id}/receipt-layout`,
  tenantInitialCredentials: (id) => `/api/tenants/${id}/initial-credentials`,
  tenantSubscriptionAdjust: (id) => `/api/tenants/${id}/subscription/adjust`,
  tenantSubscriptionTransactions: (id) => `/api/tenants/${id}/subscription-transactions`,
  tenantBlock: (id) => `/api/tenants/${id}/block`,
  tenantUnblock: (id) => `/api/tenants/${id}/unblock`,
  tenantSubscriptionCancelRequest: '/api/tenant/subscription/cancel-request',
  tenantSubscriptionPlanChangeRequest: '/api/tenant/subscription/plan-change-request',
  statisticsSubscriptionTransactionsSummary: '/api/statistics/subscription-transactions-summary',

  // Ombor (warehouses)
  warehouses: '/api/warehouses',
  warehouseById: (id) => `/api/warehouses/${id}`,

  // Inventar / mahsulotlar (Kassir Ombor uchun)
  inventoryItems: '/api/inventory-items',
  inventoryItemById: (id) => `/api/inventory-items/${id}`,
  products: '/api/products',
  productsBulkFreePrice: '/api/products/bulk-free-price',
  productFreePrice: (id) => `/api/products/${id}/free-price`,
  productById: (id) => `/api/products/${id}`,
  productPosAvailability: (id) => `/api/products/${id}/pos-availability`,
  productSalesByDay: (id) => `/api/products/${id}/sales-by-day`,

  // Menejerlar, dispatcherlar, filiallar, cashierlar
  managers: '/api/managers',
  managerById: (id) => `/api/managers/${id}`,
  branches: '/api/branches',
  branchById: (id) => `/api/branches/${id}`,
  /** Marketing: filial ↔ Telegram guruh bog‘lanishi (webhook orqali to‘ldiriladi) */
  marketingBranchTelegram: (id) => `/api/marketing/branches/${id}/telegram`,
  marketingBranchSettings: (id) => `/api/marketing/branches/${id}/settings`,
  /** Public do‘kon: filial mahsulotlari (backend: skipAuth ruxsat) */
  marketingBranchShopProducts: (id) => `/api/marketing/branches/${id}/shop-products`,
  /** Public do‘kon: slug yoki shop_subdomain segmenti (Laravel: public/branches/{slug}/shop-products) */
  publicBranchShopProductsBySlug: (slug) =>
    `/api/public/branches/${encodeURIComponent(slug)}/shop-products`,
  cashiers: '/api/cashiers',
  cashierById: (id) => `/api/cashiers/${id}`,
  /** Mijoz: ishchilar (fix oylik + oylik KPI / AI bonus %) */
  tenantStaff: '/api/tenant/staff',
  tenantStaffById: (id) => `/api/tenant/staff/${id}`,
  tenantStaffMonthlyEvaluations: '/api/tenant/staff/monthly-evaluations',
  tenantStaffMonthlyEvaluationsRun: '/api/tenant/staff/monthly-evaluations/run',
  dispatchers: '/api/dispatchers',
  dispatcherById: (id) => `/api/dispatchers/${id}`,

  /** Ichki chat — bitta umumiy kanal (platform_owner + menejerlar) */
  staffChatMessages: '/api/staff-chat/messages',
  staffChatMessage: (id) => `/api/staff-chat/messages/${encodeURIComponent(String(id))}`,
  /** Rasm/video — multipart, javobda HTTPS URL (JSON ichida `url` yoki `data.url`) */
  chatMediaUpload: '/api/chat/media',

  /** Mijoz ↔ menejer support thread */
  supportTenantMessages: (tenantId) => `/api/support/tenants/${tenantId}/messages`,

  // Buyurtmalar
  orders: '/api/orders',
  orderById: (id) => `/api/orders/${id}`,
  orderRefund: (id) => `/api/orders/${id}/refund`,
  syncOrders: '/api/sync/orders',

  /** Chakana tenant_ownerlar (POS) — tenant bo‘yicha */
  retailClients: '/api/retail-clients',
  cashierFavoriteProducts: '/api/cashier/favorites/products',
  cashierFavoriteProductToggle: (id) => `/api/cashier/favorites/products/${encodeURIComponent(String(id))}/toggle`,
  cashierZReport: '/api/cashier/z-report',
  cashierZReportSubmit: '/api/cashier/z-report/submit',
  tenantZReports: '/api/tenant/z-reports',
  tenantProductAudit: '/api/tenant/product-audit',

  // Leadlar
  leads: '/api/leads',
  leadEscalations: (leadId) => `/api/leads/${encodeURIComponent(String(leadId))}/escalations`,
  leadEscalationById: (id) => `/api/lead-escalations/${encodeURIComponent(String(id))}`,
  leadEscalationForwardToManager: (id) =>
    `/api/lead-escalations/${encodeURIComponent(String(id))}/forward-to-manager`,
  leadById: (id) => `/api/leads/${id}`,

  // Statistika
  statisticsOverview: '/api/statistics/overview',
  statisticsByRegion: '/api/statistics/by-region',
  statisticsInsights: '/api/statistics/insights',
  statisticsWeeklyOrders: '/api/statistics/weekly-orders',
  statisticsMonthlyRevenue: '/api/statistics/monthly-revenue',
  statisticsByManager: '/api/statistics/by-manager',
  statisticsExpenses: '/api/statistics/expenses',

  // Obuna
  subscriptionStatus: '/api/subscription/status',
  subscriptionInitiate: '/api/subscription/initiate',
  subscriptionMarketingAddonInitiate: '/api/subscription/marketing-addon/initiate',

  desktopAppInfo: '/api/desktop-app/info',

  // Moliya
  financeTransactions: '/api/finance/transactions',
  financeTransactionDetail: (orderId) => `/api/finance/transactions/${orderId}/detail`,
  financeTransactionTelegramInvoice: (orderId) => `/api/finance/transactions/${orderId}/telegram-invoice`,
  financeBalanceSheet: '/api/finance/balance-sheet',
  financeProfitLoss: '/api/finance/profit-loss',

  // Nasiya (credits)
  credits: '/api/credits',
  creditById: (id) => `/api/credits/${id}`,
  creditRepay: (id) => `/api/credits/${id}/repay`,
  creditTelegramReminder: (id) => `/api/credits/${id}/telegram-reminder`,
  clientCredits: '/api/client/credits',
  expenses: '/api/expenses',
  expenseCashboxAvailability: '/api/expenses/cashbox-availability',
  expenseById: (id) => `/api/expenses/${id}`,
  expensePay: (id) => `/api/expenses/${id}/pay`,
  expensePayWithProduct: (id) => `/api/expenses/${id}/pay-with-product`,
  expensePaySupplierWithProduct: '/api/expenses/pay-supplier-with-product',
  suppliers: '/api/suppliers',

  // Fakturalar va soliq
  invoices: '/api/invoices',
  invoiceById: (id) => `/api/invoices/${id}`,
  taxes: '/api/taxes',

  // Qarzlar
  debts: '/api/debts',
  debtsOverdue30: '/api/debts/overdue-30',
  debtsOverdue30Export: '/api/debts/overdue-30/export',

  // Analitika
  analyticsDashboard: '/api/analytics/dashboard',
  analyticsSalesFunnel: '/api/analytics/sales-funnel',
  analyticsCustomerSegments: '/api/analytics/customer-segments',
  analyticsAIRecommendations: '/api/analytics/ai-recommendations',

  // AI (faqat Ega)
  aiMarketingAdvice: '/api/ai/marketing-advice',
  /** Maslahat sahifasi — ERP kontekstli OpenAI chat */
  aiAdvisorChat: '/api/ai/advisor/chat',
  aiAdvisorMessages: '/api/ai/advisor/messages',

  // System
  systemDashboard: '/api/system/dashboard',
  systemHealth: '/api/system/health',
  usageMetrics: '/api/system/usage-metrics',
  settings: '/api/system/settings',
  settingsOperational: '/api/system/settings/operational',
  systemCurrencyRates: '/api/system/currency-rates',

  // Warehouses (eski format — kelajakda warehouses ga o'tkaziladi)
  warehouseOverview: '/api/warehouse/overview',
  warehouseStockIn: '/api/warehouse/stock-in',
  warehouseStockOut: '/api/warehouse/stock-out',
  warehouseTransfers: '/api/warehouse/transfers',
  warehouseInventoryAudit: '/api/warehouse/inventory-audit',
  warehouseExpiry: '/api/warehouse/expiry',
  warehouseScan: '/api/warehouse/scan',

  // Bildirishnomalar
  notifications: '/api/notifications',
  notificationRead: (id) => `/api/notifications/${id}/read`,
  notificationsReadAll: '/api/notifications/read-all',

  // Hisobotlar
  reports: '/api/reports',
  reportById: (id) => `/api/reports/${id}`,
  reportsExport: '/api/reports/export',

  // Reyting
  rating: '/api/rating',
  ratingDispatchers: '/api/rating/dispatchers',
  ratingTenants: '/api/rating/tenants',
  ratingCashiers: '/api/rating/cashiers',

  // Audit, feature flags (Ega)
  auditLogs: '/api/audit-logs',
  errorLogs: '/api/error-logs',
  featureFlags: '/api/feature-flags',
  featureFlagById: (id) => `/api/feature-flags/${id}`,
};
